<template>
  <div class="g-container-box">
    <el-row class="g-header-container">
      <el-col :span="3">
        <div class="g-header-left">熟客控制台</div>
      </el-col>
      <el-col :span="16">
        <nav-head navSel="2"></nav-head>
      </el-col>
      <el-col :span="5">
        <op-head></op-head>
      </el-col>
    </el-row>

    <el-row class="g-view-container">
      <el-col :span="3" class="g-menu-container">
        <!-- 这里如果你的菜单选中值不是 4，后面改一下 defaultSel 就行 -->
        <sidebar defaultSel="4"></sidebar>
      </el-col>

      <el-col :span="21" class="g-center-container">
        <div class="page-card">
          <div class="page-head">
            <div>
              <div class="page-title">团长管理</div>
              <div class="page-desc">查看团长权限获取情况、下属门店数量及分销收益统计</div>
            </div>
          </div>

          <div class="table-card">
            <el-table
              :data="listData"
              border
              stripe
              v-loading="tableLoading"
              class="custom-table"
              header-cell-class-name="table-header-cell"
              empty-text="暂无团长数据"
            >
              <el-table-column
                prop="authTime"
                label="权限获取时间"
                min-width="220"
              >
                <template slot-scope="scope">
                  <span class="table-main-text">{{ scope.row.authTime || "" }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="团长姓名/电话"
                min-width="240"
              >
                <template slot-scope="scope">
                  <div class="leader-cell">
                    <div class="leader-name">{{ scope.row.groupName || "" }}</div>
                    <div class="leader-phone">{{ scope.row.mobile || "" }}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="storeCount"
                label="下属门店"
                min-width="180"
                align="left"
              >
                <template slot-scope="scope">
                  <span class="table-main-text">
                    {{ formatStoreCount(scope.row.shopCount) }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column
                prop="totalIncome"
                label="团长分销收益合计"
                min-width="220"
                align="left"
              >
                <template slot-scope="scope">
                  <span class="income-text">
                    {{ formatIncome(scope.row.revenue) }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var util = require("@/common/util.js");
import { API_TZGUANLI } from "../../assets/js/api.js";

import sidebar from "../../components/sidebar.vue";
import navHead from "../../components/navHead.vue";
import opHead from "../../components/opHead.vue";

export default {
  name: "groupLeaderManagePage",
  components: {
    sidebar,
    navHead,
    opHead,
  },
  data() {
    return {
      tableLoading: false,
      listData: [],
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    getListData() {
      this.tableLoading = true;

      util.postData(
        API_TZGUANLI,
        {},
        (res) => {
          this.listData = res && res.data && res.data.data ? res.data.data : [];
          this.tableLoading = false;
        },
        (err) => {
          this.listData = [];
          this.tableLoading = false;
          this.$message.error("获取团长管理列表失败");
        },
        "application/json"
      );
    },

    formatStoreCount(value) {
      if (value === null || value === undefined || value === "") return "";
      return value + "家";
    },

    formatIncome(value) {
      if (value === null || value === undefined || value === "") return "";
      const num = Number(value);
      if (isNaN(num)) return "";
      return num.toFixed(2) + "元";
    },
  },
};
</script>

<style lang="less" scoped>
.g-container-box {
  overflow: hidden;
  background: #f5f7fa;
}

.g-header-left {
  background-color: #5c6be8;
  color: #fff;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}

.g-menu-container {
  height: calc(100vh - 60px);
  background-color: #fff;
  border-right: 1px solid #ebeef5;
}

.g-center-container {
  overflow: auto;
  height: calc(100vh - 60px);
  background-color: #eff3f6;
  padding: 20px;
  box-sizing: border-box;
}

.page-card {
  min-height: 100%;
}

.page-head {
  background: #fff;
  border-radius: 10px;
  padding: 20px 24px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.page-title {
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  color: #303133;
}

.page-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}

.table-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.custom-table {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.custom-table /deep/ .table-header-cell {
  background: #f7f9fc !important;
  color: #606266;
  font-weight: 600;
}

.custom-table /deep/ .el-table td,
.custom-table /deep/ .el-table th {
  padding: 16px 0;
}

.custom-table /deep/ .el-table__row td {
  color: #606266;
}

.custom-table /deep/ .el-table__empty-block {
  min-height: 320px;
}

.table-main-text {
  font-size: 15px;
  color: #303133;
}

.leader-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.6;
}

.leader-name {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
}

.leader-phone {
  font-size: 13px;
  color: #909399;
  margin-top: 2px;
  word-break: break-all;
}

.income-text {
  font-size: 16px;
  font-weight: 600;
  color: #d9a15d;
}

@media screen and (max-width: 1400px) {
  .g-center-container {
    padding: 16px;
  }

  .page-head {
    padding: 16px 18px;
  }

  .table-card {
    padding: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/dlsTwo/index.vue